import React from 'react';
import '../style/ProductCard.css';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../contexts/CurrencyContext';

const ProductCard = ({ product, bigCard }) => {
  const { t, i18n } = useTranslation();
  const { currencySymbol, formatPrice } = useCurrency();

  return (
    <div class="div-image">
      <div class="position-price">
        <div class={true ? 'big price-container' : 'small price-container'}>
          {t("productCard.startingPriceLabel")} {formatPrice(product.price)}{currencySymbol}
        </div>
      </div>
      <img class="button-image" src={product.previewUrl} alt={product.name} />
      <div class="button-text">
        {i18n.language === 'fr' && product.nameFR  ? product.nameFR : product.name}
      </div>
    </div>
  );
};

export default ProductCard;